import { Component,
         OnInit }               from '@angular/core';
import { Observable }                 from 'rxjs';
import { map }                        from 'rxjs/operators';
import { GalleryService,
         FileRequest }                from '../../shared/gallery.service';
import { Globals }                    from '../../common/globals';
import { TranslationService }         from '../../shared/translation.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
selector: 'hc-gallery-selector',
templateUrl: './gallery-selector.component.html',
styleUrls: ['./gallery-selector.component.scss']
})
export class GallerySelectorComponent implements OnInit {

    public items: Observable<any[]>;

    public previous = [];

    public filter: FileRequest = new FileRequest();

    public thumbSize = 120;

    public sortFn = (a, b) => {
        if (a.isDirectory !== b.isDirectory) {
        return a.isDirectory ? -1 : 1;
        }
        return a.path < b.path ? -1 : 1;
    }

    public getThumbSrc = (item: any): string => {
        return this.globals.GetUrlPrefix() + '/api/gallery/thumb/' + this.thumbSize + item.path + '?tenantID=' + this.globals.getTenantID();
    }

    constructor(
        private galleryService: GalleryService,
        private globals: Globals,
        public dialogRef: MatDialogRef<GallerySelectorComponent>,
        private trans: TranslationService
    ) {
    }

    async ngOnInit() {
        this.items = await this.galleryService.getItems(this.filter).pipe(
                        map((data) => {
                        data.sort(this.sortFn);
                        return data;
                        }));
    }

    public async search() {
        this.items = await this.galleryService.getItems(this.filter).pipe(
                        map((data) => {
                        data.sort(this.sortFn);
                        return data;
                        }));
    }

    public addNew() {
        this.globals.navigateTo('/new', { relativeToParent: true });
    }

    public openFolder(item) {
        if (this.filter.parent) { this.previous.push(this.filter.parent); }
        this.filter.parent = item.recordUID;
        this.search();
    }

    public openPrevious() {
        this.filter.parent = this.previous.pop();
        this.search();
    }

    public selectImage(item) {
        this.dialogRef.close(item);
    }
}
